import React, { useEffect, useRef, useState } from "react";
import { Button, Grid } from "@mui/material";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import SoftBox from "components/SoftBox";
import PopUp from "./Component/PopUp";
import { useAppServices } from "hook/services";
import img_empty from "assets/images/img.jpg";
import { useUploadImage } from "hook/services";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import toast from "react-hot-toast";
import { uploadImageToGhl } from "hook/services";
import { useAgencyInfo } from "context/agency";
import ReactCropModal from "layouts/super-admin/settings/Configurator/components/ReactCropModal/ReactCropModal";
import SoftTypography from "components/SoftTypography";

function NewsFeed({ formData, handleRefresh }) {
  const uploadImage = useUploadImage();
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [selectedNewsFeed, setSelectedNewsFeed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newsFeedsData, setNewsFeedsData] = useState([]);
  const [agency] = useAgencyInfo();
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [tempImageFile, setTempImageFile] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [UploadType, setUploadType] = useState("");
  const [MainImage, setMainImage] = useState("");
  const [bannerImage, setbannerImage] = useState("");

  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  const getNewsFeeds = async () => {
    const { response } = await AppService.newsFeed.Get({
      query: `account_id=${formData._id}`,
    });
    if (response) {
      setNewsFeedsData(response.data);
    }
  };

  useEffect(() => {
    if (popup) {
      setTimeout(() => {
        if (quillRef.current && !quillInstance.current) {
          quillInstance.current = new Quill(quillRef.current, {
            theme: "snow",
          });
        }
        if (selectedNewsFeed && quillInstance.current) {
          quillInstance.current.root.innerHTML = selectedNewsFeed.description || "";
        }
      }, 100);
    }
    return () => {
      if (!popup && quillInstance.current) {
        quillInstance.current = null;
      }
    };
  }, [popup, selectedNewsFeed]);

  const openPopup = () => setPopup(true);

  const closePopup = () => {
    setPopup(false);
    setSelectedNewsFeed(null);
    quillInstance.current = null;
  };

  const openCropModal = (file) => {
    setTempImageFile(file);
    setCurrentImage(URL.createObjectURL(file));
    setCropModalOpen(true);
  };

  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    setImageUploading(true);
    try {
      const file = new File([blob], "cropped-newsfeed-image.jpg", { type: "image/jpeg" });
      const image_response = await uploadImageToGhl(file, agency);

      if (image_response?.data) {
        // Update the form with the new image URL
        if (UploadType === "image") {
          if (selectedNewsFeed) {
            setSelectedNewsFeed((prev) => ({
              ...prev,
              image: image_response.data,
            }));
          } else {
            setMainImage(image_response.data);
          }
        }
        if (UploadType === "banner") {
          if (selectedNewsFeed) {
            setSelectedNewsFeed((prev) => ({
              ...prev,
              banner: image_response.data,
            }));
          } else {
            setbannerImage(image_response.data);
          }
        }
        setTempImageFile(null);
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
      setCropModalOpen(false);
    }
  };

  const handleImageUpload = async (e, type) => {
    const file = e.target.files[0];
    if (file) {
      openCropModal(file);
      setUploadType(type);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let description = quillInstance.current?.root.innerHTML.trim() || "";
    description = description.replace(/<div>/g, "<p>").replace(/<\/div>/g, "</p>");

    const payload = {
      title: e.target.title.value,
      image: MainImage || selectedNewsFeed?.image,
      banner: bannerImage || selectedNewsFeed?.banner,
      description,
      account_id: formData._id,
      agency_id: formData.agency_id,
    };

    let response;

    if (selectedNewsFeed) {
      response = await AppService.newsFeed.Update({
        payload: { ...payload, _id: selectedNewsFeed._id },
      });
    } else {
      response = await AppService.newsFeed.Create({ payload });
    }

    if (response) {
      handleRefresh();
      setPopup(false);
      setSelectedNewsFeed(null);
      setMainImage("");
      setbannerImage("");
      getNewsFeeds();
      toast.success(
        selectedNewsFeed ? "News Feed updated successfully!" : "New News Feed created successfully!"
      );
    } else {
      toast.error("Error updating Data");
    }

    setLoading(false);
  };

  const deleteNewsFeed = async (newsFeed) => {
    const { response } = await AppService.newsFeed.Delete({
      query: `_id=${newsFeed._id}`,
    });

    if (response) {
      handleRefresh();
      getNewsFeeds();
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting attachment");
    }
  };

  const editNewsFeed = (newsFeed) => {
    setSelectedNewsFeed(newsFeed);
    if (quillInstance.current) {
      quillInstance.current.root.innerHTML = newsFeed.description || "";
    }
    openPopup();
  };

  useEffect(() => {
    getNewsFeeds();
  }, [formData]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  return (
    <div>
      <p className="text-center">{success}</p>

      <div style={{ display: "flex", justifyContent: "end", margin: "0 10px" }}>
        <Button
          variant="contained"
          style={{ color: "white", background: "black" }}
          onClick={openPopup}
        >
          News Feed
        </Button>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {newsFeedsData?.map((newsFeed, index) => (
          <SoftBox
            key={index}
            style={{
              margin: "10px",
              width: "30%",
              borderRadius: "10px",
              border: "1px solid #f5f5f5",
              padding: "10px",
            }}
          >
            <img
              src={newsFeed.image || img_empty}
              alt={newsFeed.title}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
              <h4 style={{ margin: 0 }}>{newsFeed.title}</h4>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  color="white"
                  onClick={() => editNewsFeed(newsFeed)}
                  style={{ minWidth: "auto", padding: "8px" }}
                >
                  <img src={editIcon} width={20} style={{ cursor: "pointer" }} alt="Edit" />
                </Button>
                <Button
                  variant="contained"
                  color="white"
                  style={{
                    background: "#e44d36",
                    color: "#fff",
                    minWidth: "auto",
                    padding: "8px",
                  }}
                  onClick={() => deleteNewsFeed(newsFeed)}
                >
                  <img src={deleteIcon} width={20} style={{ cursor: "pointer" }} alt="Delete" />
                </Button>
              </div>
            </div>
          </SoftBox>
        ))}
      </div>

      <PopUp
        open={popup}
        handleClose={closePopup}
        title={selectedNewsFeed ? "Edit News Feed" : "New News Feed"}
      >
        <form onSubmit={handleSubmit} onKeyPress={handleKeyPress}>
          <div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Title</label>
                  <input
                    className="form-control-agust"
                    name="title"
                    type="text"
                    placeholder="Title"
                    defaultValue={selectedNewsFeed?.title || ""}
                    required
                  />
                </SoftBox>
              </div>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Image</label>
                  <input
                    className="form-control-agust"
                    name="image"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, "image")}
                  />
                  {selectedNewsFeed?.image && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={selectedNewsFeed.image}
                        alt="Current news feed"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  )}
                </SoftBox>
              </div>
            </div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Banner Image</label>
                  <input
                    className="form-control-agust"
                    name="banner"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, "banner")}
                  />
                  <Grid item xs={12} display={"flex"} alignItems="center" style={{ padding: 0 }}>
                    <SoftTypography
                      variant="p"
                      className="roboto-family"
                      style={{ fontSize: "14px", marginTop: "4px" }}
                    >
                      1MB maximum size. 5:2 ratio. Recommended dimensions: 1752 x 716 pixels.
                    </SoftTypography>
                  </Grid>
                  {selectedNewsFeed?.banner && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={selectedNewsFeed.banner}
                        alt="Current news feed"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  )}
                </SoftBox>
              </div>
            </div>
            <div style={{ padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Description</label>
                <div ref={quillRef} style={{ height: "250px", marginBottom: "20px" }} />
              </SoftBox>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              margin: "0 10px",
            }}
          >
            <Button
              variant="contained"
              type="submit"
              style={{ color: "white", background: "black" }}
              disabled={loading || imageUploading}
            >
              {loading ? "Processing..." : selectedNewsFeed ? "Update News Feed" : "Save News Feed"}
            </Button>
          </div>
        </form>
      </PopUp>

      <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
        aspectRatio={UploadType === "image" ? 1 / 1 : 7 / 2}
      />
    </div>
  );
}

export default NewsFeed;
